import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Modal, Select, Input, Button, Layout, Row, Col, Table, Icon, List } from 'antd'

import CategorySelect from '@components/CategorySelect/'

import { policies } from '@services/api'

import * as styles from './styles.scss'

@inject((store: any) => {
    const { popupStore, categoriesStore, policyCollectionsStore, collectionsStore } = store
    return { popupStore, categoriesStore, policyCollectionsStore, collectionsStore }
})
@observer
class AddPolicyCollectionPopup extends Component<any, any> {
    async componentDidMount() {
        await this.props.collectionsStore.getCollections()
    }

    closePopup = () => {
        this.props.popupStore.togglePopup(false)
    }

    setError = (errorName, errorMsg) => {
        this.props.popupStore.addErrors(errorName, errorMsg)
        return false
    }

    validatePolicy = async id => {
        try {
            await this.props.collectionsStore.getCollection(id)
            return true
        } catch {
            return false
        }
    }

    savePolicy = async id => {
        if (await this.validatePolicy(id)) {
            await this.props.policyCollectionsStore.addCollection(this.props.location.pathname.split('/').pop(), id)
            await this.props.policyCollectionsStore.getList(this.props.location.pathname.split('/').pop())
            this.props.popupStore.togglePopup(false)
        }
    }

    handlePageChange = async page => {
        await this.props.collectionsStore.getCollections(page)
    }
    render() {
        const { popupStore, policyCollectionsStore, collectionsStore } = this.props

        return (
            <Modal
                title={'בחירת זכות מכל הבריאות שתקושר לפוליסה'}
                visible={popupStore.popupType === 'addPolicyCollection'}
                cancelText="ביטול"
                onCancel={this.closePopup}
                footer={null}
            >
                <div style={{ paddingBottom: '2rem' }}>
                    <div style={{ display: 'flex', marginBottom: '1rem' }}>
                        <Input.Search
                            style={{ width: '60%' }}
                            placeholder="חיפוש לפי שם או תיאור"
                            value={collectionsStore.filters.freeSearch ? collectionsStore.filters.freeSearch : null}
                            onChange={async e => {
                                await collectionsStore.setFilter('freeSearch', e.target.value)
                                await collectionsStore.getCollections()
                            }}
                        />
                        <Input.Search
                            style={{ width: '40%', marginRight: '0.3rem' }}
                            placeholder="חיפוש מזהה"
                            value={collectionsStore.filters.id ? collectionsStore.filters.id : null}
                            onChange={async e => {
                                await collectionsStore.setFilter('id', e.target.value)
                                await collectionsStore.getCollections()
                            }}
                        />
                    </div>
                    <List
                        dataSource={collectionsStore.list}
                        renderItem={item => {
                            let link
                            const existing = policyCollectionsStore.list.find(existing => existing.id === item['id'])
                            if (!existing) {
                                link = (
                                    <Button
                                        style={{ textDecoration: 'underline' }}
                                        onClick={() => this.savePolicy(item['id'])}
                                    >
                                        קשר זכות זו
                                    </Button>
                                )
                            } else {
                                link = 'זכות זו כבר מקושרת'
                            }
                            return (
                                <List.Item
                                    key={item['id']}
                                    style={{
                                        textAlign: 'right',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        width: '100%',
                                        padding: '0.5rem'
                                    }}
                                >
                                    <div
                                        style={{
                                            cursor: 'pointer',
                                            width: '100%',
                                            display: 'flex',
                                            justifyContent: 'space-between'
                                        }}
                                    >
                                        <div>
                                            <span style={{ marginRight: '1rem' }}>{item['id']}</span> | {item['name']}
                                        </div>
                                        <div style={{ whiteSpace: 'nowrap' }}>{link}</div>
                                    </div>
                                </List.Item>
                            )
                        }}
                        pagination={{
                            total: collectionsStore.paging.total,
                            pageSize: 10,
                            onChange: e => this.handlePageChange(e)
                        }}
                    />
                </div>
            </Modal>
        )
    }
}

export default withRouter(AddPolicyCollectionPopup)
